// Confetti burst for the celebration (SC-H4, D9 visual reward). Net-new, no library — an inline
// canvas animation matching the prototype: ~90 rotating rects, brand colors, gravity, ~110 frames,
// then it clears itself. Skipped entirely under prefers-reduced-motion (returns before any work).

const COLORS = ['#0d9488', '#f59e0b', '#7c3aed', '#0284c7', '#fde68a', '#a7f3d0']; // teal · amber · lav-d · sky-d · amber-l · mint

// Returns a stop() so the caller can cancel the RAF loop if the overlay closes early.
export function runConfetti(canvas) {
  if (!canvas) return { stop() {} };
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return { stop() {} };
  const ctx = canvas.getContext('2d');
  if (!ctx) return { stop() {} };
  const W = canvas.width = (canvas.offsetWidth || 320) * 2;
  const H = canvas.height = (canvas.offsetHeight || 480) * 2;
  const P = Array.from({ length: 90 }, () => ({
    x: W / 2, y: H * 0.35,
    vx: (Math.random() - 0.5) * 28, vy: -Math.random() * 26 - 8,
    r: Math.random() * 10 + 6, c: COLORS[Math.random() * COLORS.length | 0],
    a: Math.random() * 6, s: Math.random() * 0.3 - 0.15,
  }));
  let f = 0, raf = 0, stopped = false;
  const go = () => {
    if (stopped) return;
    ctx.clearRect(0, 0, W, H);
    P.forEach(p => {
      p.x += p.vx; p.y += p.vy; p.vy += 0.9; p.vx *= 0.98; p.a += p.s;
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a);
      ctx.fillStyle = p.c; ctx.fillRect(-p.r / 2, -p.r / 4, p.r, p.r / 2);
      ctx.restore();
    });
    if (++f < 110) raf = requestAnimationFrame(go);
    else ctx.clearRect(0, 0, W, H);
  };
  go();
  return { stop() { stopped = true; if (raf) cancelAnimationFrame(raf); try { ctx.clearRect(0, 0, W, H); } catch (_) {} } };
}
